var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header"},[_c('v-btn',{attrs:{"color":"amber"},on:{"click":_vm.toWebEx}},[_vm._v(_vm._s(_vm.btnExplain))])],1),_c('Post',{attrs:{"type":"form","isExpert":_vm.isExpert}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }